<template>
  <div>
    {{ count }}
  </div>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    endCount: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 50,
    },
  },
  data: function() {
    return {
      count: 0,
    };
  },
  mounted() {
    this.counter();
  },
  methods: {
    counter() {
      let myInterval = setInterval(() => {
        if (this.count === this.endCount) {
          clearInterval(myInterval);
        } else {
          this.count++;
        }
      }, this.duration / this.endCount);
    },
  },
};
</script>
